import { TabSkeleton } from '../Shared/TabSkeleton';

const ROOM_ROWS = [
  'avatar-row',
  'input-row',
  'input-row',
  'input-row',
  'input-row',
  'input-row',
  'left-only-row',
] as const;

export const RoomTabSkeleton = () => (
  <TabSkeleton count={2} rows={ROOM_ROWS} headerButton />
);
